import { useState, useRef } from 'react';
import useGetGroups from '../../API/hooks/groups/useGetGroups';
import { FilterConfig } from '../../components/common/DropdownFilter/types';
import { IconKeys } from '../../components/common/Icon/IconKeys';
import Modal from '../../components/common/Modal/Modal';
import Toolbar from '../../components/common/Toolbar/Toolbar';
import S from './GroupsPageStyles';
import ItemsList, { ItemsListRef } from '../../components/common/ItemsList/ItemsList';
import useGetFleetId from '../../API/hooks/useGetFleetId';
import useGetRole from '../../API/hooks/useGetRole';
import GroupsItem from './GroupsItem/GroupsItem';
import AddGroup from './Modals/AddGroup/AddGroup';
import { getLocalStorageKey } from '../../utils/storageUtils';
import useGetCurrentPage from '../../API/hooks/useGetCurrentPage';
import CloneGroup from './Modals/CloneGroup/CloneGroup';
import MergeGroup from './Modals/MergeGroup/MergeGroup';
import { groupsPageFilters } from '../../constants/FilterDefault';
import useLocalStorage from '../../API/hooks/useLocalStorage';

const SEARCH_CONFIG = [
  {
    type: 'sortBy',
    display: 'radio',
    options: [
      { name_ASC: 'Group name: asc' },
      { name_DESC: 'Group name: desc' },
    ],
  },
] as FilterConfig[];

function GroupsPage(): JSX.Element {
  const fleetId = useGetFleetId();
  const {
    isFleetViewer,
  } = useGetRole();
  const [addGroupModalOpen, toggleAddGroupModal] = useState(false);
  const [modalMergeState, toggleModalMergeState] = useState(false);
  const [modalCloneState, toggleModalCloneState] = useState(false);
  const [filters, setFilters] = useLocalStorage(getLocalStorageKey('groups-page-filters'), groupsPageFilters);
  const currentPage = useGetCurrentPage();
  const itemsListRef = useRef<ItemsListRef>(null);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const handleSuccess = (): void => {
    itemsListRef.current?.toggleSelection(false);
  };

  const BUTTONS = [
    {
      title: 'Add new group',
      iconKey: IconKeys.PLUS,
      action: () => toggleAddGroupModal(true),
      hide: isFleetViewer,
    },
  ];

  const LIST_BUTTONS = [
    {
      title: 'Merge',
      action: () => toggleModalMergeState(true),
      hide: isFleetViewer,
      height: '25px',
      // background: theme.colors.red,
      // hoverBackground: theme.colors.red,
      disabled: selectedItems.length < 2,
    },
    {
      title: 'Clone',
      action: () => toggleModalCloneState(true),
      hide: isFleetViewer,
      height: '25px',
      // background: theme.colors.red,
      // hoverBackground: theme.colors.red,
      disabled: selectedItems.length < 1,
    },
  ];

  return (
    <S.Wrapper>
      <Toolbar
        title="Groups"
        buttons={BUTTONS}
      />
      <ItemsList
        ref={itemsListRef}
        entity="groups"
        fleetId={fleetId}
        filtersConfig={SEARCH_CONFIG}
        filters={filters}
        defaultFilters={groupsPageFilters}
        setFilters={setFilters}
        hasSearch
        getQuery={useGetGroups}
        curentPage={currentPage}
        buttons={LIST_BUTTONS}
        onSelect={setSelectedItems}
      >
        <GroupsItem />
      </ItemsList>
      {addGroupModalOpen && (
        <Modal
          title="Add new group"
          state={addGroupModalOpen}
          toggleState={toggleAddGroupModal}
        >
          <AddGroup
            fleetId={fleetId}
            onCancel={() => toggleAddGroupModal(false)}
          />
        </Modal>
      )}
      {modalCloneState && (
        <Modal
          title="Clone group"
          state={modalCloneState}
          toggleState={toggleModalCloneState}
        >
          <CloneGroup
            fleetId={fleetId as string}
            groupIds={selectedItems}
            toggleModal={toggleModalCloneState}
            onSuccess={handleSuccess}
          />
        </Modal>
      )}
      {modalMergeState && (
        <Modal
          title="Merge group into"
          state={modalMergeState}
          toggleState={toggleModalMergeState}
        >
          <MergeGroup
            fleetId={fleetId as string}
            groupIds={selectedItems}
            toggleModal={toggleModalMergeState}
            onSuccess={handleSuccess}
          />
        </Modal>
      )}
    </S.Wrapper>
  );
}

export default GroupsPage;
